import { DRIVER_OPERATION_TYPE } from "./data";

const useHeaderButtons = () => {
  const data = [
    {
      id: DRIVER_OPERATION_TYPE.TRIP,
      padding: "filter",
      width: "settingsDriversTab",
      text: "Trips",
      hasPermission: true,
    },
    {
      id: DRIVER_OPERATION_TYPE.SESSION,
      padding: "filter",
      width: "settingsDriversTab",
      text: "Sessions",
      hasPermission: true,
    },
  ];

  return data;
};

export default useHeaderButtons;
